/* ═══════════════════════════════════════════
   APC — Apparel Product Card behaviour
   Config comes from window.APC_CONFIG, written
   by snippets/product-card-vars.liquid.
═══════════════════════════════════════════ */
(function () {
  'use strict';
  if (window._apcV3) return;
  window._apcV3 = true;

  function cfg() {
    return window.APC_CONFIG || {};
  }
  function text(key, fallback) {
    var t = cfg().text || {};
    return t[key] != null && t[key] !== '' ? t[key] : fallback;
  }

  /* ══ Colour name → hex, from the theme's swatch map ══ */
  var COLOUR_MAP = null;
  function colourMap() {
    if (COLOUR_MAP) return COLOUR_MAP;
    COLOUR_MAP = {};
    var raw = cfg().colourMap || {};
    Object.keys(raw).forEach(function (k) {
      COLOUR_MAP[k.toLowerCase().trim().replace(/\s+/g, ' ')] = raw[k];
    });
    return COLOUR_MAP;
  }

  function hex(name) {
    var n = (name || '').toLowerCase().trim().replace(/\s+/g, ' ');
    if (!n) return null;
    var map = colourMap();
    if (map[n]) return map[n];
    if (/^#?[0-9a-f]{3}([0-9a-f]{3})?$/i.test(n)) return n.charAt(0) === '#' ? n : '#' + n;
    /* Let the browser resolve plain CSS colour names (e.g. "teal") */
    try {
      var s = document.createElement('span');
      s.style.color = '';
      s.style.color = n;
      if (s.style.color) {
        document.body.appendChild(s);
        var rgb = getComputedStyle(s).color;
        document.body.removeChild(s);
        if (rgb && rgb !== 'rgba(0, 0, 0, 0)' && rgb !== 'rgb(0, 0, 0)') return rgb;
        if (rgb === 'rgb(0, 0, 0)' && (n === 'black' || n === '#000' || n === '#000000')) return rgb;
      }
    } catch (e) {}
    return null;
  }

  /* ── Swap product card image with crossfade ── */
  function swapImage(card, imgSrc) {
    if (!imgSrc || !cfg().swatchSwapsImage) return;
    var wrap = card.querySelector('.apc-image-wrap');
    var img = wrap && wrap.querySelector('img');
    if (!img) return;
    wrap.classList.add('apc-img-fading');
    setTimeout(function () {
      img.src = imgSrc;
      /* Also update srcset so the browser doesn't revert to the original */
      if (img.srcset) img.srcset = imgSrc;
      wrap.querySelectorAll('source').forEach(function (s) { s.srcset = imgSrc; });
      wrap.classList.remove('apc-img-fading');
    }, 180);
  }

  function applySwatches(root) {
    (root || document).querySelectorAll('.apc-swatch[data-colour-name]').forEach(function (el) {
      var h = hex(el.dataset.colourName);
      if (h) {
        el.style.background = h;
        el.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,.1)';
      }
    });
  }

  function initCarousel(wrapEl, trackEl, prevBtn, nextBtn) {
    if (!trackEl || !wrapEl) return;
    function check() {
      var ov = trackEl.scrollWidth > trackEl.clientWidth + 2;
      wrapEl.classList.toggle('has-overflow', ov);
      wrapEl.classList.toggle('fade-left', trackEl.scrollLeft > 2);
      wrapEl.classList.toggle('fade-right', ov && trackEl.scrollLeft + trackEl.clientWidth < trackEl.scrollWidth - 2);
    }
    check(); requestAnimationFrame(check); setTimeout(check, 300);
    trackEl.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    if (window.ResizeObserver) new ResizeObserver(check).observe(trackEl);
    if (prevBtn) prevBtn.addEventListener('click', function () { trackEl.scrollBy({ left: -110, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { trackEl.scrollBy({ left: 110, behavior: 'smooth' }); });
  }

  function getVariants(card) {
    var el = document.getElementById(card.dataset.variantJsonId);
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function optKey(idx) {
    return idx >= 0 && idx <= 2 ? ['option1', 'option2', 'option3'][idx] : null;
  }

  function readIdx(ds, key) {
    var raw = ds[key];
    if (raw === undefined || raw === '') return -1;
    var n = parseInt(raw, 10);
    return isNaN(n) ? -1 : n;
  }

  function findVariant(variants, cIdx, cVal, sIdx, sVal) {
    var cKey = optKey(cIdx);
    var sKey = optKey(sIdx);
    var list = variants.filter(function (v) {
      var cOk = !cKey || cVal == null || v[cKey] === cVal;
      var sOk = !sKey || sVal == null || v[sKey] === sVal;
      return cOk && sOk;
    });
    return list.find(function (v) { return v.available; }) || list[0] || null;
  }

  function refreshSizes(card, colourVal) {
    var variants = getVariants(card);
    var cKey = optKey(readIdx(card.dataset, 'colourIdx'));
    var sKey = optKey(readIdx(card.dataset, 'sizeIdx'));
    if (!sKey) return;
    var hideOos = !!cfg().hideOosSizes;
    card.querySelectorAll('.apc-size-btn').forEach(function (btn) {
      var match = variants.find(function (v) {
        var cOk = !cKey || colourVal == null || v[cKey] === colourVal;
        return cOk && v[sKey] === btn.dataset.sizeValue;
      });
      var avail = match ? match.available : false;
      btn.classList.toggle('apc-size-btn--oos', !avail);
      btn.disabled = !avail;
      btn.hidden = hideOos && !avail;
      if (!avail) btn.classList.remove('apc-size-btn--active');
    });
  }

  /* ── Pause/resume parent Swiper autoplay while card UI is open ── */
  function nearestSwiper(card) {
    var el = card && card.closest && card.closest('swiper-slider');
    if (!el || !el.slider || !el.slider.autoplay) return null;
    return el;
  }
  function cardWantsPause(card) {
    var form = card.querySelector('.apc-form');
    var sgOpen = card.querySelector('.apc-sg-panel.open');
    return !!(form && form.classList.contains('size-open')) || !!sgOpen;
  }
  function syncCardPause(card) {
    if (!card) return;
    var want = cardWantsPause(card);
    if (want === !!card._apcPaused) return;
    card._apcPaused = want;
    var sw = nearestSwiper(card);
    if (!sw) return;
    sw._apcPauseCount = (sw._apcPauseCount || 0) + (want ? 1 : -1);
    if (sw._apcPauseCount < 0) sw._apcPauseCount = 0;
    try {
      if (sw._apcPauseCount > 0) sw.slider.autoplay.stop();
      else sw.slider.autoplay.start();
    } catch (e) {}
  }

  function openSizePicker(card) {
    var form = card.querySelector('.apc-form');
    if (form) form.classList.add('size-open');
    card.querySelectorAll('.apc-sg-panel.open').forEach(function (p) { p.classList.remove('open'); });
    syncCardPause(card);
  }

  function closeSizePicker(card) {
    var form = card.querySelector('.apc-form');
    var picker = card.querySelector('.apc-size-inline');
    if (form) form.classList.remove('size-open');
    if (picker) {
      picker.querySelectorAll('.apc-size-btn').forEach(function (b) { b.classList.remove('apc-size-btn--active'); });
      var conf = picker.querySelector('.apc-size-confirm');
      if (conf) {
        conf.disabled = true;
        conf.classList.remove('ready', 'loading');
        conf.querySelector('.apc-size-confirm-text').textContent = text('sizePrompt', 'Pick a Size');
        conf.querySelector('.apc-size-confirm-price').textContent = '';
        delete conf.dataset.variantId;
      }
    }
    card.querySelectorAll('.apc-sg-panel.open').forEach(function (p) { p.classList.remove('open'); });
    syncCardPause(card);
  }

  function initCard(card) {
    applySwatches(card);
    initCarousel(
      card.querySelector('.apc-colour-wrap'), card.querySelector('.apc-colour-picker'),
      card.querySelector('.apc-colour-arrow--prev'), card.querySelector('.apc-colour-arrow--next')
    );
    initCarousel(
      card.querySelector('.apc-size-carousel-wrap'), card.querySelector('.apc-size-picker'),
      card.querySelector('.apc-size-arrow--prev'), card.querySelector('.apc-size-arrow--next')
    );
    if (cfg().hideOosSizes) {
      var active = card.querySelector('.apc-colour-btn.active');
      refreshSizes(card, active ? active.dataset.colourValue : null);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('product-card[data-product-id]').forEach(initCard);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    initAll(document);

    /* Re-init cards injected by the theme editor or AJAX section renders */
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    /* ── Colour click ── */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.apc-colour-btn');
      if (!btn || btn.dataset.colourAvailable === 'false') return;
      var card = btn.closest('.apc-card');
      card.querySelectorAll('.apc-colour-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var disp = card.querySelector('.apc-colour-name-display');
      if (disp) disp.textContent = btn.dataset.colourValue;
      swapImage(card, btn.dataset.imgSrc);
      refreshSizes(card, btn.dataset.colourValue);
      if (card.querySelector('.apc-size-inline')) {
        closeSizePicker(card);
        openSizePicker(card);
      }
    });

    /* ── Size pill click ── */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.apc-size-btn');
      if (!btn || btn.classList.contains('apc-size-btn--oos') || btn.disabled) return;
      var card = btn.closest('.apc-card');
      var cBtn = card.querySelector('.apc-colour-btn.active');
      var cVal = cBtn ? cBtn.dataset.colourValue : null;
      var cIdx = readIdx(card.dataset, 'colourIdx');
      var sIdx = readIdx(card.dataset, 'sizeIdx');
      card.querySelector('.apc-size-picker').querySelectorAll('.apc-size-btn')
        .forEach(function (b) { b.classList.remove('apc-size-btn--active'); });
      btn.classList.add('apc-size-btn--active');
      var match = findVariant(getVariants(card), cIdx, cVal, sIdx, btn.dataset.sizeValue);
      var confirm = card.querySelector('.apc-size-confirm');
      if (confirm) {
        confirm.dataset.variantId = match ? match.id : '';
        confirm.querySelector('.apc-size-confirm-price').textContent =
          match && cfg().atcShowPrice ? (match.price || '') : '';
        confirm.querySelector('.apc-size-confirm-text').textContent = text('sizeConfirm', 'Add to Bag');
        confirm.disabled = !match;
        confirm.classList.toggle('ready', !!match);
      }
    });

    /* ── Back button ── */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.apc-size-back')) return;
      closeSizePicker(e.target.closest('.apc-card'));
    });

    /* ── Size Guide toggle ── */
    document.addEventListener('click', function (e) {
      var tr = e.target.closest('.apc-sg-trigger');
      if (tr) {
        var p = document.getElementById(tr.dataset.target);
        if (p) {
          p.classList.toggle('open');
          syncCardPause(tr.closest('.apc-card'));
        }
        return;
      }
      var cl = e.target.closest('.apc-sg-close');
      if (cl) {
        var p2 = document.getElementById(cl.dataset.target);
        if (p2) {
          p2.classList.remove('open');
          syncCardPause(cl.closest('.apc-card'));
        }
      }
    });

    /* ── Form submit ── */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.apc-form');
      if (!form) return;
      e.preventDefault();
      var card = form.closest('.apc-card');
      var sizeInline = form.querySelector('.apc-size-inline');
      if (sizeInline && !form.classList.contains('size-open')) {
        var ac = card && card.querySelector('.apc-colour-btn.active');
        if (!ac && card) {
          var fc = card.querySelector('.apc-colour-btn:not(.apc-colour-btn--oos)');
          if (fc) { fc.click(); return; }
        }
        openSizePicker(card);
        return;
      }
      var vi = form.querySelector('.apc-variant-input');
      doATC(form, vi ? vi.value : '');
    });

    /* ── Confirm button ── */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.apc-size-confirm.ready');
      if (!btn || btn.classList.contains('loading')) return;
      var vid = btn.dataset.variantId;
      if (!vid) return;
      btn.classList.add('loading');
      btn.querySelector('.apc-size-confirm-text').textContent = text('adding', 'Adding…');
      var card = btn.closest('.apc-card');
      if (card) closeSizePicker(card);
      doATC(btn.closest('.apc-form'), vid);
    });
  });

  /* ══ Add to Cart ══ */
  function doATC(form, variantId) {
    if (!variantId) return;
    var btn = form && form.querySelector('.apc-atc');
    var txt = btn && btn.querySelector('.apc-atc-text');
    var orig = txt ? txt.textContent : text('atc', 'Add to Bag');
    if (btn) btn.disabled = true;
    if (txt) txt.textContent = text('adding', 'Adding…');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (err) { throw err; }); return r.json(); })
      .then(function () {
        if (txt) txt.textContent = text('added', 'Added ✓');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count,[data-cart-count],.cart-icon-bubble,.cart-count-bubble')
          .forEach(function (el) { el.textContent = cart.item_count; });
        var t = document.querySelector('#offcanvas-cart-label span');
        if (t) t.textContent = cart.item_count;
        if (cfg().openCartDrawer === false) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          refreshAndOpenCart();
        }
      })
      .catch(function (err) { console.error('APC add to cart:', err); if (txt) txt.textContent = text('atcError', 'Error'); })
      .finally(function () {
        setTimeout(function () {
          if (btn) btn.disabled = false;
          if (txt) txt.textContent = orig;
        }, 2500);
      });
  }

  /* ══ Cart drawer ══ */
  function refreshAndOpenCart() {
    var cart = document.getElementById('offcanvas-cart');
    if (!cart) { openCartDrawer(); return; }
    fetch('/?sections=cart-drawer,offcanvas-cart,cart-notification,mini-cart,ajax-cart')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var done = false;
        Object.values(sections).forEach(function (html) {
          if (done || !html || typeof html !== 'string') return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var n = doc.querySelector('cart-container,.cart-container');
          var o = document.querySelector('cart-container,.cart-container');
          if (n && o) { o.innerHTML = n.innerHTML; done = true; }
        });
        if (!done) {
          return fetch('/cart', { headers: { 'Accept': 'text/html' } })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              ['cart-container', '.cart-container', '#cart-items', '.cart-items', '[data-cart-items]', '.offcanvas-body']
                .forEach(function (sel) {
                  var n = doc.querySelector(sel), o = cart.querySelector(sel);
                  if (n && o) { o.innerHTML = n.innerHTML; }
                });
            });
        }
      })
      .catch(function (e) { console.error(e); })
      .finally(openCartDrawer);
  }

  function openCartDrawer() {
    var el = document.getElementById('offcanvas-cart');
    if (!el) return;
    if (typeof bootstrap !== 'undefined' && bootstrap.Offcanvas) {
      bootstrap.Offcanvas.getOrCreateInstance(el).show();
      return;
    }
    if (typeof $ !== 'undefined' && $.fn && $.fn.offcanvas) { $(el).offcanvas('show'); return; }
    el.classList.add('show', 'showing');
    el.style.visibility = 'visible';
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var bd = document.querySelector('.offcanvas-backdrop');
    if (!bd) {
      bd = document.createElement('div');
      bd.className = 'offcanvas-backdrop fade show';
      document.body.appendChild(bd);
    }
    function close() {
      el.classList.remove('show', 'showing');
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (bd) bd.remove();
    }
    var cls = el.querySelector('[data-bs-dismiss="offcanvas"],.btn-close');
    if (cls) cls.addEventListener('click', close);
    bd.addEventListener('click', close);
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));
  }
})();
